import { render } from "./pageContact.vue?vue&type=template&id=2bce4e9a&scoped=true"
import script from "./pageContact.vue?vue&type=script&lang=js"
export * from "./pageContact.vue?vue&type=script&lang=js"

import "./pageContact.vue?vue&type=style&index=0&id=2bce4e9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bce4e9a"]])

export default __exports__